module.exports = __webpack_public_path__ + "static/img/advert_1.766a5d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ShopSharePrinting/advert_1.png
// module id = KBrD
// module chunks = 10